<div class="flex flex-col gap-3">

  <div class="flex items-center justify-between gap-3">
    <div>
      <h4 class="font-semibold text-sm">Mindest- und Sollbestand</h4>
      <p class="text-xs text-base-content/70">
        Fällt der Bestand einer StockRow <strong>unter</strong> den Mindestbestand, werden
        alle Zeilen dieses Technikers im Versandticket bis zum Sollbestand aufgefüllt.
      </p>
    </div>
    <div class="flex gap-2">
      @if (selection().length > 0) {
        <button type="button" class="bm-btn bm-btn-error bm-btn-sm" (click)="entfernen()">
          {{ selection().length }} entfernen
        </button>
      }
      <button type="button" class="bm-btn bm-btn-primary bm-btn-sm" (click)="hinzufuegen()">
        + Hinzufügen
      </button>
    </div>
  </div>

  @if (fehler()) {
    <div class="bm-alert bm-alert-error bm-alert-soft">
      <span class="text-sm">{{ fehler() }}</span>
    </div>
  }

  @if (rows().length === 0 && !loading()) {
    <div class="p-4 text-center text-sm text-base-content/70 border border-dashed border-base-300 rounded-lg">
      Noch keine Bestände hinterlegt.
    </div>
  } @else {
    <ag-grid-angular
      class="ag-theme-quartz"
      style="height: 320px; width: 100%"
      [theme]="hawkTheme"
      [rowData]="rows()"
      [columnDefs]="colDefs()"
      [defaultColDef]="defaultColDef"
      [rowSelection]="'multiple'"
      [suppressRowClickSelection]="true"
      [stopEditingWhenCellsLoseFocus]="true"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged()"
    />
  }
</div>
